import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RbacService, OauthService } from '@stg-js-ngx-core/oauth';
import { fromPromise } from 'rxjs/internal-compatibility';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { SERVICE_PHRASE } from '../constants/constants';
import { LoggedInUserDetailsService } from './logged-in-user-details.service';
import { of } from 'rxjs';
import * as moment from "moment";

declare var aaimsCommonService: any;
declare var selfServiceValues: any;

@Injectable({
  providedIn: 'root'
})
export class SyncopeService {
  syncopeConfig: any = [];
  private userObj: any;
  constructor(
    private http: HttpClient,
    private oauthService: OauthService,
    private rbacService: RbacService,
    private loggedInUserDetailsService: LoggedInUserDetailsService) { }

  getUsers(
    realm: string,
    page: number = 1,
    size: number = 25,
    sort: string = 'username asc',
    fiql: string = ''
  ) {
    return fromPromise(aaimsCommonService.getUsers(this.oauthService.oAuthToken,page, size, sort, realm, fiql))
      .pipe(map((res: any) => this.modifyUsersData(res.data, null)));
  }

  getSyncopeUser(key?: string){
    return fromPromise(aaimsCommonService.getUser(this.oauthService.oAuthToken,key ? key : this.rbacService.username)).pipe(catchError(err => {
      console.error(err);
      return of(null);
    }));
  }
  
  addSyncopeUser(userInfo, realm, auxClass, resources) {
    return aaimsCommonService.addUser(this.oauthService.oAuthToken, userInfo, realm, auxClass, userInfo.email,resources);
  }

  updateSyncopeUser(userInfo, editProfileFlag, realm, auxClass, resources) {
    return aaimsCommonService.changeUser(
      this.oauthService.oAuthToken,
      userInfo.key,
      this.formatUserData(userInfo),
      editProfileFlag,
      realm,
      auxClass,
      userInfo.email,
      resources);
  }

  set syncopeUserObj(obj){
    this.userObj = this.formatUserObj(obj);
  }

  get syncopeUserObj(){
    return this.userObj;
  }

  formatUserObj(result: any){
    let user: any = {};
    if ( result.plainAttrs ){
      for (let y = 0; y < result.plainAttrs.length; y++) {
        user[result.plainAttrs[y].schema] = result.plainAttrs[y].values[0];
      }

      user.mustChangePassword = result.mustChangePassword;
      user.status = result.status;
      user.key = result.key;
      user.securityQuestionKey = result.securityQuestion;
      user.username = result.username;
      user.realm = result.realm;
      user.accountSuspended = user.status && user.status.toLowerCase() === 'suspended';
    }


    return user;
  }

  changeUserStatus(userInfo, accountStatus, resources): Promise<any> {
    return aaimsCommonService.changeUserStatus(this.oauthService.oAuthToken, userInfo.key, accountStatus, resources);
  }

  resetSecurity(userInfo, resources, auxClass): Promise<any> {
    return aaimsCommonService.resetSecurity(this.oauthService.oAuthToken, userInfo.key, userInfo, resources, auxClass);
  };

  modifyUsersData(data:any, orgs:any) {
    let usersData: any = {};
    usersData.metadata = {};
    usersData.metadata.http_status_code = "200";
    usersData.data = [];

    const secObjects = this.rbacService.rbacProfile.secured_objects;
    if (this.rbacService.currentRoleName === 'User' || secObjects.length === 0) {
      usersData.metadata.resultCount = 0;
      return usersData;
    }

    for (let t = 0; t < secObjects.length; t++) {
      if (secObjects[t].object_name === 'User Administration' && secObjects[t].access_type === 'BLOCK') {
        usersData.metadata.resultCount = 0;
        return usersData;
      }
    }

    usersData.metadata.resultCount = data.totalCount;
    let syncopeUsersData:any = {};

    for (let x = 0; x < data.result.length; x++) {
      const result = data.result[x];
      for (let y = 0; y < result.plainAttrs.length; y++) {
        const propertyName = result.plainAttrs[y].schema,
          propertyValue = result.plainAttrs[y].values[0];

        if (propertyName === 'resetSecurity') {
          syncopeUsersData[propertyName] = propertyValue === 'true';
        }
        else if (propertyName === 'hireDate') {
          syncopeUsersData[propertyName] = propertyValue ? moment(propertyValue).format('MM/DD/YYYY') : null;
        }
        else {
          syncopeUsersData[propertyName] = propertyValue;
        }
      }

      syncopeUsersData.mustChangePassword = result.mustChangePassword;

      syncopeUsersData.status = result.status;

      syncopeUsersData.account_locked = syncopeUsersData.status.toUpperCase() === 'SUSPENDED';

      if ((data.result[x].securityQuestion === null || syncopeUsersData.mustChangePassword) && syncopeUsersData.status.toUpperCase() === 'ACTIVE') {
        syncopeUsersData.account_locked = false;

        if (syncopeUsersData.allowIDMNotifications && syncopeUsersData.allowIDMNotifications.toLowerCase()==='false'){
          syncopeUsersData.status = 'Active';
        }
        else{
        syncopeUsersData.status = 'User Action Required';
        }
      }


      syncopeUsersData.key = result.key;
      syncopeUsersData.changePwdDate = result.changePwdDate;
      syncopeUsersData.creationDate = result.creationDate;
      syncopeUsersData.creator = result.creator;
      syncopeUsersData.lastChangeDate = result.lastChangeDate;
      syncopeUsersData.lastModifier = result.lastModifier;
      syncopeUsersData.securityQuestionKey = result.securityQuestion;
      syncopeUsersData.username = result.username;

      if(orgs){
        for (let k = 0; k < orgs.length; k++) {
          if(syncopeUsersData.organizationName === orgs[k].teamName){
            syncopeUsersData.organizationDescription=orgs[k].organization;
          }
        }
      }

      usersData.data.push(syncopeUsersData);
      syncopeUsersData = {};
    }

    return usersData;
  }

  getSecurityQuestionsByUser(userName): Promise<any> {
    return aaimsCommonService.getSecurityQuestionByUser(this.oauthService.oAuthToken, userName);
  }

  verifyGuid(guid, userKey, userName): Promise<any> {
    return aaimsCommonService.verifyGuidByUserDetails(this.oauthService.oAuthToken, guid, userKey, userName);
  };

  getSecurityQuestions(): Promise<any> {
    return aaimsCommonService.getSecurityQuestions(this.oauthService.oAuthToken);
  };

  changeSecurityQuestion(key, question, answer): Promise<any> {
    return aaimsCommonService.changeSecurityQuestion(this.oauthService.oAuthToken,key, question, answer);
  };

  changePassword(userKey, password, resources): Promise<any> {
    return aaimsCommonService.changePassword(this.oauthService.oAuthToken, userKey, password, resources);
  };

  setPassword(userKey, userInfo, resources, auxClass): Promise<any> {
    return aaimsCommonService.setPassword(this.oauthService.oAuthToken, userKey, userInfo, resources, auxClass);
  };

  confirmPasswordReset(token, newPassword): Promise<any> {
    return aaimsCommonService.confirmPasswordReset(this.oauthService.oAuthToken, token, newPassword);
  };

  requestPasswordReset(username, securityAnswer): Promise<any> {
    return aaimsCommonService.requestPasswordReset(this.oauthService.oAuthToken,username,securityAnswer);
  };

  getConfigurations(selfService?: boolean) {
    let url = environment.urls.getSyncopeConfigurations;
    let localHeaders = {};
    if (selfService) {
      url = environment.urls.getSelfSyncopeConfigurations;
      localHeaders['Authorization'] = 'Bearer ' + selfServiceValues.serviceValue(SERVICE_PHRASE, url, null, this.loggedInUserDetailsService.calculatedOffset);
    }

    return this.http.get(url, { headers: localHeaders })
      .pipe(map((res: any) => {
        res = selfServiceValues.extractJSON(SERVICE_PHRASE, res.result);
        this.syncopeConfig = res;
        return res;
      }), catchError(err => { console.error(err); return of(null)}));
  }

  private formatUserData(userInfo) {
    let userData = {...userInfo};

    if(userData.hasOwnProperty('status')){
      delete userData.status;
    }

    if(userData.hasOwnProperty('key')){
      delete userData.key;
    }

    if(userData.hasOwnProperty('securityQuestionKey')){
      delete userData.securityQuestionKey;
    }

    return userData;
  };
}
